import React from "react";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import RadioGroup from "@mui/material/RadioGroup";

import {
  CHANGE_DATA_ARCHITECTURE,
  CHANGE_DATA_EQUIPMENT,
  CHANGE_DATA_FIREEQUIPMENT,
} from "./Word";

// 💄 共通ロジックをフックにしちゃう
const useRadioInput = (storeKey, actionType, key) => {
  const { b: building, page } = useParams();
  const value = useSelector(
    (state) => state[storeKey]?.[building]?.[page]?.[key]
  );
  const dispatch = useDispatch();

  const change = (val) => {
    dispatch({
      type: actionType,
      payload: { [key]: val },
      bulding: building,
      page,
    });
  };

  return { value, change };
};

// 💄 ベースとなる共通コンポーネント
const BaseInputRadio = ({ storeKey, actionType, key_num, children }) => {
  const { value, change } = useRadioInput(storeKey, actionType, key_num);

  return (
    <RadioGroup
      name="controlled-radio-buttons-group"
      value={value}
      onChange={(e) => change(e.target.value)}
      onClick={(e) => {
        if (e.target.value === value) {
          e.target.value = "";
          change("");
        }
      }}
    >
      {children}
    </RadioGroup>
  );
};

// 💄 各種エクスポート（用途に応じて切り替え）
export const InputRadio = React.memo((props) => (
  <BaseInputRadio
    {...props}
    storeKey="Architecture"
    actionType={CHANGE_DATA_ARCHITECTURE}
  />
));

export const InputRadioEquip = React.memo((props) => (
  <BaseInputRadio
    {...props}
    storeKey="Equipment"
    actionType={CHANGE_DATA_EQUIPMENT}
  />
));

export const InputRadioFireEquip = React.memo((props) => (
  <BaseInputRadio
    {...props}
    storeKey="FireEquipment"
    actionType={CHANGE_DATA_FIREEQUIPMENT}
  />
));
